import { BaseDto } from './base.dto';

export class SaleUnitTypeDto extends BaseDto {
  name: string;
}
